<p>delete-survey-confirmation-modal works!</p>
